import React from "react"
import PagesHero from "../shared/PagesHero"
import { useStaticQuery, graphql } from "gatsby"
import aboutIcon from "../../assist/icons/about/aboutHeroIcon.svg"

const AboutHero = ({ lang }) => {
  const data = useStaticQuery(graphql`
    {
      strapiAboutPageImages(name: { eq: "aboutImage" }) {
        image {
          childImageSharp {
            fluid(maxWidth: 1100, quality: 100) {
              ...GatsbyImageSharpFluid_tracedSVG
            }
          }
        }
      }
    }
  `)
  const words = {
    ar: {
      aboutTitle: "حولنا",
      paragraph1:
        ",مؤسسة الرسالة هي منظمة إنسانیة غیر حکومیة، غیر ربحية، غیر سیاسیة",

      paragraph2: `
       مکرسة لإنقاذ الأرواح وتخفیف المعاناة من خلال تأمین سبل العیش والأمن الغذائي والمیاه والصرف الصحي وخدمات الرعایة الصحیة والتدریب وبرامج الإغاثة والتنمیة، لبناء القدرات المحلیة في المجتمعات التي تعاني من النقص النزوح مع المرونة في الاستجابة بسرعة للحاجات الطارئة
       `,
    },
    en: {
      aboutTitle: "About Us",
      paragraph1:
        "Al-Resala Foundation is a non-governmental, non-profit, non-political, ",

      paragraph2: `
      humanitarian organization dedicated to saving lives and alleviating suffering through securing livelihoods, food security, water and sanitation, health care services, training, relief and development programs, to build local capacities in communities suffering from shortage and displacement, with the flexibility to respond quickly to emergencies.       `,
    },
    tr: {
      aboutTitle: "Hakkımızda",
      paragraph1:
        "Alrisele derneği, insani sivil bir dernektir. Kâr amacı gütmeyen, siyasetten bağımsız  bir kuruluştur.",

      paragraph2: `
      Yaşam kaynakları, gıda güvenliği, su, kanalizasyon ve sağlık bakımı hizmetleri sağlamaktadır.
      Yerinden edilmiş kişileri ve yokluktan sıkıntı çeken topluluklardaki yerel yetenkleri geliştirmek için eğitimler, yardım ve geliştirme programları temin ederek acıyı hafifletmek ve hayatları kurtarmak için kendini adamıştır. Acıl ihtiyaçlara hızla ve çeviklikle icabet etmektedir.`,
    },
  }
  return (
    <PagesHero
      image={data.strapiAboutPageImages.image.childImageSharp.fluid}
      icon={aboutIcon}
      title={words[lang].aboutTitle}
      parag={words[lang].paragraph1}
      paragraph2={words[lang].paragraph2}
      activeLink={
        lang === "ar"
          ? "عن الرسالة"
          : lang === "en"
          ? "About Al Resala"
          : "Biz kimiz"
      }
      lang={lang}
    />
  )
}

export default AboutHero
